// Before & after CDN project images (set 2)
export const BEFORE_AFTER_3 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab28834372453112fc6acd2.webp";
export const BEFORE_AFTER_4 =
  "https://assets.cdn.filesafe.space/iehMW4z3GZgoPjqmxz5p/media/6ab288344091fa65e6d0d392.webp";
